module.exports = __webpack_public_path__ + "static/img/en10.0bc3fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en10.jpg
// module id = ilBP
// module chunks = 1